import { createFileRoute, getRouteApi } from "@tanstack/react-router"

import { CreateTeamPage } from "@/app/components/create-team-page"

const shellRoute = getRouteApi("/_app-shell")

export const Route = createFileRoute("/_app-shell/team/new")({
  head: () => ({ meta: [{ title: "Create a team - Kestly" }] }),
  component: function CreateTeamRoute() {
    const { teams } = shellRoute.useLoaderData()
    return <CreateTeamPage enabled={teams.enabled} />
  },
})
